import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import type { RouterContext } from '@shared/config/router-context';
import { canAccessAnalyticsMove } from '@shared/lib';
import { resolveAnalyticsMoveTabPath } from '@pages/analytics/ui/analytics-move-tabs';

/**
 * Analytics - Move Overview
 *
 * Route: /:locale/analytics/overview
 */
export const Route = createFileRoute('/$locale/_authenticated/analytics/overview')({
  validateSearch: z.object({
    tab: z.string().optional(),
  }),
  beforeLoad: ({ context, params, search }) => {
    const { ability } = context as RouterContext;

    if (!canAccessAnalyticsMove(ability)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/$locale/unauthorized',
        params: { locale: params.locale },
      });
    }

    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: resolveAnalyticsMoveTabPath(search.tab),
      params: { locale: params.locale },
    });
  },
});
